export default {
  // 新增职位名称
  employmentTitleAdd: "/settings/employmentTitle/add",
  // 修改职位名称信息
  employmentTitleUpdate: "/settings/employmentTitle/update",
  // 根据主键id删除职位名称
  employmentTitleDelete: "/settings/employmentTitle/delete",
  // 职位名称展示页(全量)
  employmentTitleList: "/settings/employmentTitle/list",
  // 职位名称下拉框数据(仅在线数据)
  employmentTitleDropdown: "/settings/employmentTitle/dropdown",
};
